import { render } from "./SearchIcon.svg?vue&type=template&id=0b8905f8"
const script = {}
script.render = render

export default script